import type { Labels, UniqueId } from '~/domain/commons.domain';

export enum PlanType {
	SILAE_EXPENSE = 'SILAE_EXPENSE',
	SILAE_EXPENSE_PRO = 'SILAE_EXPENSE_PRO',
	MY_EXPENSE = 'MY_EXPENSE'
}

export type OrganizationCompactDto = UniqueId & {
	name: string;
	plan: PlanType;
	chiftIntegrationLabel: string;
	isDeactivated: boolean;
};

export type ExpenseWorkflowStep = {
	metaState: string;
	labels: Labels;
};

export type OrganizationMetricsDto = {
	/**
	 * Total vault capacity used at the given date.
	 * Expressed in bytes: divide twice by 1_024 to get megabytes.
	 **/
	vaultCapacityUsed: 0;
	vaultExpenseCount: 0;
};

export type OrganizationDto = OrganizationCompactDto &
	OrganizationConfigDto &
	OrganizationMetricsDto & {
		createdAt: number;
		userAdminId: string;
		dossierGuid?: string;
	};

export type OrganizationConfigDto = {
	organizationProfiles: OrganizationProfileDto[];
	expensesWorkflowSteps: ExpenseWorkflowStep[];
};

export type OrganizationProfileDto = UniqueId & {
	iconRef: string;
	labels: Record<string, string>;
};
